export class FordVehicleDetailModel {
  "bodyStyle": string;
  "bodyStyleDescription": string;
  "brandCode": string;
  "buildDate": string;
  "catalyticConverterCode": string;
  "catalyticConverterDescription": string;
  "commonName": string;
  "dieselParticulateFilterCode": string;
  "dieselParticulateFilterDescription": string;
  "driveCode": string;
  "driveDescription": string;
  "emissionRequirementMfcCode": string;
  "emissionRequirementMfcDescription": string;
  "emissionRequirementPfcCode": string;
  "emissionRequirementPfcDescription": string;
  "engineDescription": string;
  "engineFeatureCode": string;
  "engineFuelCapabilityCode": string;
  "engineFuelCapabilityDescription": string;
  "fuelType": string;
  "jointVenture": string;
  "localVehicleLineDescription": string;
  "modelYear": number;
  "paint": string;
  "paintDescription": string;
  "productType": string;
  "productTypeVehicleLineCode": string;
  "saleDate": Date;
  "source": string;
  "territory": string;
  "territoryDescription": string;
  "transmission": string;
  "transmissionDescription": string;
  "transmissionInd": string;
  "vehicleLineFeatureCode": string;
  "version": string;
  "versionDescription": string;
  "vin": string;
  "warrantyEndDate": Date;
  "warrantyStartDate": Date;
}
